import styled from "styled-components";
import { FaQuestionCircle } from "react-icons/fa";
import { createStyledIcon } from "utils/iconUtils";

const QuestionCircleIcon = createStyledIcon(FaQuestionCircle);

export const ConfirmationModalWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

export const ConfirmationTitle = styled.h2`
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${({ theme }) => theme.colors.warning};
  margin-bottom: 16px;
`;

export const ConfirmationIcon = styled(QuestionCircleIcon)`
  margin-right: 8px;
  font-size: 2rem;
  color: ${({ theme }) => theme.colors.warning};
`;

export const ConfirmationMessage = styled.p`
  font-size: 1rem;
  text-align: center;
  color: #424242;
  margin-bottom: 24px;
`;

export const ButtonContainer = styled.div`
  display: flex;
  justify-content: space-around;
  width: 100%;
`;
